<script>
  let { entitlement } = $props();
</script>

<div class="entitlement">{entitlement.name}</div>
